import { Box, Tab, Tabs } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import { commonToolItems } from '../configs/toolItemsConfig'
import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { useSelector } from 'react-redux'

const userSelector = createSelector(
  [(state: RootState) => state.auth],
  (auth) => auth.user,
)

function Settings() {
  const boxRef = useRef<HTMLDivElement>(null)
  const [boxHeight, setBoxHeight] = useState(0)
  const [selectedTabIndex, setSelectedTabIndex] = useState(0)
  const user = useSelector(userSelector)

  const settingsTool = commonToolItems.find((tool) => tool.label === 'Settings')
  const tabs =
    !!user && settingsTool?.nestedRoutes
      ? settingsTool?.nestedRoutes?.filter(
          (route) => !!!route.roles || route.roles.includes(user?.role.name),
        )
      : []
  const SelectedComponent = tabs[selectedTabIndex]
    ? tabs[selectedTabIndex].component
    : null

  const handleTabClick = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTabIndex(newValue)
  }

  useEffect(() => {
    const calculateHeight = () => {
      if (boxRef.current) {
        setBoxHeight(boxRef.current.clientHeight)
      }
    }

    calculateHeight()
    window.addEventListener('resize', calculateHeight)

    return () => {
      window.removeEventListener('resize', calculateHeight)
    }
  }, [])

  return (
    <Box sx={{ width: '100%', height: '100%' }}>
      <Box ref={boxRef} sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={selectedTabIndex}
          onChange={handleTabClick}
          sx={{
            minHeight: 0,
            '& .MuiTabs-indicator': {
              display: 'none',
              justifyContent: 'center',
              backgroundColor: 'transparent',
            },
            '& .MuiTabs-indicatorSpan': {
              maxWidth: 0,
              width: 0,
              backgroundColor: '#635ee7',
            },
          }}
        >
          {tabs.map((tab, index) => (
            <Tab
              disableRipple
              key={index}
              label={tab.label}
              sx={{
                minWidth: 0,
                minHeight: 0,
                alignItems: 'start',
                textTransform: 'capitalize',
                color: '#04002E',
                fontSize: '0.94rem',
                display: 'flex',
                pl: 0,
                pr: '2rem',
                py: '0.75rem',
                justifyContent: 'flex-start',
                '&.Mui-selected': {
                  color: '#1705E5',
                },
              }}
            />
          ))}
        </Tabs>
      </Box>
      <Box
        sx={{
          display: 'flex',
          height: `calc(100% - ${boxHeight}px)`,
        }}
      >
        {SelectedComponent && <SelectedComponent />}
      </Box>
    </Box>
  )
}

export default Settings
